export default __webpack_public_path__ + "static/media/image_6.5407fc8d.jpg";